@if (!detailMode) {
  <div class="legend-container">
    <div class="col-5 col-sm-4 col-md-3 col-lg-2 float-start">
      <fieldset class="form-group">
        <label class="col-form-label font-color-black" translate="PLANERA_DETAIL_PRODUKTIONSMAL_VISAR"></label>
        <div aid="plan-legend-title">
          {{ produktionsomrade }}{{ 'PLANERA_DETAIL_PRODUKTIONSMAL_PRODUKTIONSOMRADE_PERIOD_AVDELARE' | translate }}{{ produktionsmalPlan.period | date:'LLLL' | lowercase }}
        </div>
      </fieldset>
    </div>
    <div class="col-4 col-sm-3 col-md-3 col-lg-2 float-start">
      <fieldset class="form-group">
        <label class="col-form-label font-color-black" translate="PLANERA_DETAIL_PRODUKTIONSMAL_HAMTAT"></label>
        <div>{{ produktionsmalPlan.responseDate | date:'HH:mm d MMM'}}</div>
      </fieldset>
    </div>
    <div class="col-11 col-sm-11 col-md-11 col-lg-7 float-start">
      <ng-container *ngTemplateOutlet="legendColors; context: { showPeriodsatt: true }"></ng-container>
    </div>
  </div>
}

@if (detailMode) {
  <div class="legend-container">
    <div class="col-12">
      <ng-container *ngTemplateOutlet="legendColors; context: { showPeriodsatt: false }"></ng-container>
    </div>
  </div>
}

<ng-template #legendColors let-showPeriodsatt="showPeriodsatt">
  <div class="col-4 col-sm-4 col-md-2 col-lg-2 offset-lg-2">
    <fieldset class="form-group">
      <label class="col-form-label font-color-black"
      translate="PLANERA_DETAIL_PRODUKTIONSMAL_MAL"></label>
      <div>
        <i class="fas fa-lg fa-square produktionsmal-plan mal" aria-hidden="true"
          container="body"
          ngbPopover="{{ 'PLANERA_DETAIL_PRODUKTIONSMAL_POPOVER_HELP_MAL' | translate}}"
        triggers="mouseenter:mouseleave"></i>
      </div>
    </fieldset>
  </div>
  <div class="col-4 col-sm-4 col-md-2">
    <fieldset class="form-group">
      <label class="col-form-label font-color-black">Klara</label>
      <div>
        <i class="fas fa-lg fa-square produktionsmal-plan klara" aria-hidden="true"
          container="body"
          ngbPopover="Total volym av de arbetsordrar som är klara"
        triggers="mouseenter:mouseleave"></i>
      </div>
    </fieldset>
  </div>
  <div class="col-4 col-sm-4 col-md-2">
    <fieldset class="form-group">
      <label class="col-form-label font-color-black"
      translate="PLANERA_DETAIL_PRODUKTIONSMAL_PRODUKTSATT"></label>
      <div>
        <i class="fas fa-lg fa-square produktionsmal-plan produktsatt" aria-hidden="true"
          container="body"
          ngbPopover="{{ 'PLANERA_DETAIL_PRODUKTIONSMAL_POPOVER_HELP_PRODUKTSATT' | translate}}"
        triggers="mouseenter:mouseleave"></i>
      </div>
    </fieldset>
  </div>
  <div class="col-4 col-sm-4 col-md-2">
    <fieldset class="form-group">
      <label class="col-form-label font-color-black"
      translate="PLANERA_DETAIL_PRODUKTIONSMAL_PERIODSATT"></label>
      <div>
        <i class="fas fa-lg fa-square produktionsmal-plan periodsatt" aria-hidden="true"
          container="body"
          ngbPopover="Total volym av de arbetsorder som är periodsatta eller schemalagda. Volymen baseras på arbetsorderns direktutbyte."
        triggers="mouseenter:mouseleave"></i>
      </div>
    </fieldset>
  </div>
  <div class="col-4 col-sm-4 col-md-2">
    <fieldset class="form-group">
      <label class="col-form-label font-color-black"
      translate="PLANERA_DETAIL_PRODUKTIONSMAL_LEVERANSVIRKE"></label>
      <div>
        <i class="fas fa-lg fa-square produktionsmal-plan leveransvirke" aria-hidden="true"
          container="body"
          ngbPopover="{{ 'PLANERA_DETAIL_PRODUKTIONSMAL_POPOVER_HELP_LEVERANSVIRKE' | translate}}"
        triggers="mouseenter:mouseleave"></i>
      </div>
    </fieldset>
  </div>
</ng-template>
